import { LinkIcon } from './LinkIcon';

/**
 * author: Google
 * id 462769C2-0A30-4B31-B66C-55168B10D705
 * name link
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/link.svg
 * tags
 */
export const InsertLinkIcon = LinkIcon;
export default InsertLinkIcon